import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { EventEmitter } from 'events';
import LSEQTree from 'lseqtree';
import { Communication } from './communication/Communication';
import Marker from './view/marker';

var debug = require('debug')('CRATE:Document');

var Document =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Document, _EventEmitter);

  function Document(options, documentIndex, crate) {
    var _this;

    _classCallCheck(this, Document);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Document).call(this));
    _this._options = options;
    _this.documentIndex = documentIndex;
    _this.crate = crate;
    _this.documentId = _this._options.signalingOptions.session;
    _this._lastChanges = new Date().getTime();
    _this.documentActiveWatcher;
    _this.state = 'active';
    _this.name = options.name; //User ID

    _this.user = options.user;
    _this.uid = _this.user.id;
    _this.lastSentMsgId = null;
    return _this;
  }

  _createClass(Document, [{
    key: "initView",
    value: function () {
      var _initView = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, View;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._options.display) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return import(
                /* webpackMode: "eager", webpackChunkName: "Crate-View" */
                './View.js');

              case 3:
                _ref = _context.sent;
                View = _ref.View;
                this._view = new View(this._options, this, this._options.containerID);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function initView() {
        return _initView.apply(this, arguments);
      };
    }()
    /**
     * connect to the session of the document
     */

  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var options;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = this._options;
                this._communication = new Communication(_objectSpread({
                  document: this
                }, this._options));
                _context2.next = 4;
                return this._communication.initConnection();

              case 4:
                this.sequence = new LSEQTree(this._communication._data_comm.broadcast._causality.local.e);
                this.delta = {
                  ops: []
                  /* TODO:Think about the creation of modules without view */

                };
                _context2.next = 8;
                return this._communication.initModules();

              case 8:
                // #1B if it is imported from an existing object, initialize it with these
                // #2 grant fast access
                this._foglet = this._communication._foglet;
                this.broadcast = this._communication._data_comm.broadcast;
                this.broadcastCaret = this._communication._behaviors_comm.broadcast;
                this.rps = this._communication._data_comm.network.rps;
                this.causality = this._communication.causality;
                this.signalingOptions = options.signalingOptions;

                if (!options.importFromJSON) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 17;
                return this.loadFromJSON(options.importFromJSON);

              case 17:
                if (options.display) {
                  this._view.init();
                }

                this.emit('connected');

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function init() {
        return _init.apply(this, arguments);
      };
    }()
  }, {
    key: "setMessageState",
    value: function setMessageState(msg) {
      if (this._options.display) {
        this._view.setMessageState(msg);
      }
    }
    /**
     * setLastChangesTime set the last time of changes
     */

  }, {
    key: "setLastChangesTime",
    value: function setLastChangesTime() {
      this._lastChanges = new Date().getTime();
      this.refreshDocument(this.sequence);
      this.emit('changed');

      if (this.state === 'sleep') {//TODO:wake up the server if it existes
      }

      this.state = 'active';
      this.resetSleepTimer();
    }
    /**
     * Reset the sleep timer
     */

  }, {
    key: "resetSleepTimer",
    value: function resetSleepTimer() {
      var _this2 = this;

      clearTimeout(this.documentActivityWatcher);
      this.documentActivityWatcher = setTimeout(function () {
        _this2.state = 'sleep';

        _this2.emit('sleep');
      }, this._options.documentActivityTimeout);
    }
    /*!
     * \brief create the core from an existing object
     * \param object the object to initialize the core model of crate containing a 
     * sequence and causality tracking metadata
     */

  }, {
    key: "loadFromJSON",
    value: function () {
      var _loadFromJSON = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(object) {
        var _this3 = this;

        var local;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.broadcast._causality = this.broadcast._causality.constructor.fromJSON(object.causality);
                local = this.broadcast._causality.local;
                this._communication._behaviors_comm.broadcast._causality.local.e = local.e;
                this.sequence.fromJSON(object.sequence);
                this.sequence._s = local.e;
                this.sequence._c = local.v;
                this.getDeltaFromSequence().then(function (delta) {
                  _this3.delta = delta;
                }).catch(function (err) {
                  console.error(err);
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function loadFromJSON(_x) {
        return _loadFromJSON.apply(this, arguments);
      };
    }()
    /**
     * saveDocument save the document in local storage
     * @return {[type]} [description]
     */

  }, {
    key: "saveDocument",
    value: function saveDocument() {
      try {
        var timeNow = new Date().getTime();
        var document = {
          date: timeNow,
          title: this.name,
          delta: this._view._editor.viewEditor.editor.delta,
          sequence: this.sequence,
          causality: this.causality,
          name: this.name,
          webRTCOptions: this.webRTCOptions,
          markers: {},
          signalingOptions: this.signalingOptions
        };
        store.set('CRATE2-' + this.signalingOptions.session, document);
        debug('Document saved => ', document);
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    }
  }, {
    key: "refreshDocument",
    value: function refreshDocument(sequence) {
      var _this4 = this;

      var WhoWriteIt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this._options.display) {
        clearTimeout(this.refreshDocumentTimeout);
        this.refreshDocumentTimeout = setTimeout(function () {
          var range = _this4._view._editor.viewEditor.getSelection();

          _this4._view._editor.viewEditor.setContents(_this4.getDelta(), 'silent');

          _this4._view._editor.viewEditor.setSelection(range, 'silent');

          _this4._view._editor.updateCommentsLinks();

          _this4.getDeltaFromSequence().then(function (delta) {
            _this4.delta = delta;

            var range = _this4._view._editor.viewEditor.getSelection();

            _this4._view._editor.viewEditor.setContents(_this4.getDelta(), 'silent');

            _this4._view._editor.viewEditor.setSelection(range, 'silent');

            _this4._view._editor.updateCommentsLinks();
          });
        }, 10);
      }
    }
  }, {
    key: "getDelta",
    value: function getDelta() {
      var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.delta;
      var ops = delta.ops.slice(0);
      ops.push({
        insert: '\n'
      });
      return {
        ops: ops
      };
    }
  }, {
    key: "getDeltaFromSequence",
    value: function getDeltaFromSequence() {
      var _this5 = this;

      var WhoWriteIt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (resolve, reject) {
        var LSEQNodes = _this5.getLSEQNodes();

        var ops = [];
        LSEQNodes.forEach(function (node) {
          var op = {
            insert: node.e.content,
            attributes: node.e.attributes
          };

          if (WhoWriteIt) {
            var id = node.t.s;
            op.attributes.color = Marker.getColor(id);
          }

          ops.push(op);
        });
        var delta = {
          ops: ops
        };
        resolve(delta);
      });
    }
  }, {
    key: "getLSEQNodes",
    value: function getLSEQNodes() {
      var LSEQNodeArray = [];
      var root = this.sequence.root;

      var preorder = function preorder(node) {
        if (node.e && node.e != '') {
          LSEQNodeArray.push(node);
        }

        var children = node.children;
        children.forEach(function (child) {
          preorder(child);
        });
      };

      preorder(root);
      return LSEQNodeArray;
    }
  }, {
    key: "reload",
    value: function reload() {
      this._communication.close();

      if (this._view) {
        this._view.close();
      }

      this.init();
    }
  }, {
    key: "close",
    value: function close() {
      this._communication.close();

      clearTimeout(this.documentActivityWatcher);
      clearTimeout(this.refreshDocumentTimeout);

      if (this._view) {
        this._view.close();
      }

      this.crate.removeDocument(this.documentIndex);
    }
    /**
     *  get the id of the session
     */

  }, {
    key: "getId",
    value: function getId(options) {
      return options.signalingOptions.session;
    }
    /**
     * focus on the next session
     */

  }, {
    key: "moveToNext",
    value: function moveToNext() {
      this.crate.moveToNext(this.documentId);
    }
    /**
     * focus on the previous session
     */

  }, {
    key: "moveToPrevious",
    value: function moveToPrevious() {
      this.crate.moveToPrevious(this.documentId);
    }
  }, {
    key: "createNewDocument",
    value: function createNewDocument(documentId) {
      this.crate.createNewDocument(documentId);
    }
  }]);

  return Document;
}(EventEmitter);

export { Document as default };